var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cspan data-bind=\"text: title\"\u003E\u003C\u002Fspan\u003E";;return pug_html;};
module.exports = template;